<template>
	<div class="box" :class="cssClasses" :id="id">
		<div class="box__header" v-if="title">
			<el-tooltip effect="dark" :content="title" placement="top" :disabled="!titleTooltip">
				<h1 v-if="titleLevel === 1">{{ title }}</h1>
				<h2 v-if="titleLevel === 2">{{ title }}</h2>
				<h3 v-if="titleLevel === 3">{{ title }}</h3>
			</el-tooltip>

			<el-avatar v-if="count" :size="40"> {{ count }} </el-avatar>
			<slot name="boxheaderRight" />
		</div>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'TheBox',
	data() {
		return {};
	},
	props: {
		title: {
			type: String,
			default: '',
		},
		id: {
			type: String,
			default: '',
		},
		titleLevel: {
			type: Number,
			default: 2,
		},
		bgColor: {
			type: String,
			default: 'white',
		},
		count: {
			type: Number,
			default: 0,
		},
		hasDataGrid: {
			type: Boolean,
			default: false,
		},
		alignment: {
			type: String,
			default: '',
		},
		titleTooltip: {
			type: Boolean,
			default: false,
		},
		insideTable: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		cssClasses() {
			let cssClasses = [`bg--${this.bgColor}`];
			if (this.hasDataGrid === true) {
				cssClasses.push('datagrid');
			}
			if (this.alignment === 'center') {
				cssClasses.push('box--center');
			}
			if (this.insideTable === true) {
				cssClasses.push('box--astable');
			}

			return cssClasses;
		},
	},
	methods: {},
	mounted() {},
};
</script>

<style lang="scss">
@use '../scss/vars.scss' as *;

.box {
	width: 100%;
	margin: 0;
	padding: var(--box-padding-y) var(--box-padding-x);
	border-radius: 12px;
	box-sizing: border-box;
	box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
	background-color: #fff;
	position: relative;

	.box__header {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 1.5rem;

		h1,
		h2,
		h3 {
			margin-bottom: 0;
		}

		.el-icon {
			height: 1.25rem;
			width: 1.25rem;
			margin-left: 2rem;
			svg {
				color: var(--el-color-red);
				height: 100%;
				width: 100%;
			}
		}
	}

	.el-avatar {
		background-color: var(--el-color-red);
		margin-left: 2rem;
	}

	&.datagrid {
		.box__header {
			margin-bottom: 1rem;
		}
	}

	&.box--center {
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	&.box--astable,
	&.box--astable + .box--astable {
		margin-top: 0;
		margin-bottom: 2rem;

		.box__header {
			flex-wrap: nowrap;
			align-items: flex-start;

			.has-status {
				margin-left: 0.5rem;
				white-space: pre;
				font-size: 0.75rem;
				padding: 0.3rem;
				line-height: 1;
			}
		}

		.button-panel {
			margin-top: 1rem !important;
			margin-bottom: 0;

			.el-button:first-child {
				margin-top: 0;
			}
			.el-button:last-child {
				margin-bottom: 0;
			}
		}
	}
}

.box + .box {
	margin-top: 3rem;
}
</style>
